<app-navigation *ngIf="authenticationService?.getCurrentUser()"> </app-navigation>
<div class="main-wrapper">
  <app-header *ngIf="authenticationService?.getCurrentUser()"></app-header>
  <router-outlet></router-outlet>
</div>
